const { formatText } = require('core/i18n').i18n;

module.exports = {
    getSocialShareSolidarity: ()  => ({
        title: formatText('socialShare-solidarityTitle'),
        subtitle: formatText('socialShare-solidarityDescription'),
        socialNetworks: {
            showFacebook: true,
            showTwitter: true,
            showLinkedIn: true,
            showEmail: true,
            URL: formatText('socialShare-solidarityURL'),
        },
        propsCard: {
            title: formatText('socialShare-solidarityCardTitle'),
            description: formatText('socialShare-solidarityCardDescription'),
            link: formatText('socialShare-solidarityLink'),
            imageURL: 'https://images.unsplash.com/photo-1504567961542-e24d9439a724?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1867&q=80',
        },
        shareSocialText: formatText('socialShare-socialShareText'),
        propsFacebook: {
            facebookImg: 'https://images.unsplash.com/photo-1541658016709-82535e94bc69?ixlib=rb-1.2.1&auto=format&fit=crop&w=3300&q=80',
            facebookURL: 'https://www.openbank.es/tarjeta-solidaria-debito',
            facebookTitle: formatText('socialShare-solidarityFacebookTitle'),
            facebookDescription: formatText('socialShare-solidarityFacebookDescription'),
        },
        propsTwitter: {
            twitterDescription: formatText('socialShare-solidarityTwitterDescription'),
            recommendedTwitter: "@openbank_es",
            hashtagTwitter: ['solidario, openbank']
        },
        propsLinkedIn: {
            linkedInTitle: formatText('socialShare-solidarityLinkedinTitle'),
            linkedInSource: 'Openbank',
            linkedInName: 'LinkedIn'
        },
        propsEmail: {
            fromEmail: "email.example@gmail.com",
            subjectEmail: formatText('socialShare-solidarityEmailSubject'),
            contentEmail: formatText('socialShare-solidarityEmailContent'),
            toEmail: ""
        }
    })
};
